
import CiviiChatConnection from '@/civii-chat/scripts/civiiChatConnection.js'
import {ENDPOINT_CIVII_CHAT_USER_CHANNEL} from '@/civii-chat/scripts/civiiChatUrls.js'

const TIPO_EMISOR = {
    AGENTE: 1,
    USUARIO: 2,
    SISTEMA: 3
}

const TIPO_MENSAJE = {
    PEDIR_TERMINOS_Y_CONDICIONES: 1,
    INFORME_OPERACION: 2,
    OPERACION_NO_DISPONIBLE: 3,
    CONVERSACION: 4,
    FIN_CONVERSACION: 5
}

const DEFAULT_MESSAGE_TYPE = 0;

const serverMessageHandler = {}
serverMessageHandler[DEFAULT_MESSAGE_TYPE] = {
    createMessage: function({message, messagePosition}){
        return createCiviiTextMessage(parseMessageData(message), messagePosition);
    }
};
serverMessageHandler[TIPO_MENSAJE.PEDIR_TERMINOS_Y_CONDICIONES] = {
    createMessage: function({state}){
        let credentials = JSON.parse(JSON.stringify(state.userCredentials));
        credentials.conversationId = state.conversationId;
        return {
            type: 'CiviiChatForm',
            userData: credentials,
            startTime: new Date().getTime()
        }
    }
};
serverMessageHandler[TIPO_MENSAJE.CONVERSACION] = {
    createMessage: function({messageData, messagePosition}){
        return createCiviiTextMessage(messageData.mensaje, messagePosition);
    }
};
serverMessageHandler[TIPO_MENSAJE.OPERACION_NO_DISPONIBLE] = {
    createMessage: function({messageData, messagePosition, dispatch}){
        dispatch('closeConnection');
        return createCiviiTextMessage(messageData.mensaje, messagePosition);
    }
};
serverMessageHandler[TIPO_MENSAJE.FIN_CONVERSACION] = {
    createMessage: function({messageData}){
        return  {
            type: 'CiviiChatFeedback',
            conversationData: {
                conversationId: messageData.codigoConversacion
            },
            endTime: new Date().getTime()
        }
    }
};

export default {
    namespaced: true,
    state: {
        serverConnection: null,
        userCredentials: {},
        conversationId: null,
        agentIsConnected: false
    },
    mutations: {
        setConnection(state, civiiChatConnection){
            state.serverConnection = civiiChatConnection;
        },
        setUserCredentials(state, userCredentials){
            state.userCredentials = userCredentials;
        },
        setConversationId(state, conversationId){
            state.conversationId = conversationId;
        },
        setAgentIsConnected(state, agentIsConnected) {
            state.agentIsConnected = agentIsConnected;
        }
    },
    actions: {
        handleOnOpen({commit}){
            console.log('civiichat open');    
            commit('setDisableInput', true, {root: true});
            //commit('setConversationId', null);
            commit('setAgentIsConnected', false);
        },
        handleOnMessage({state, commit, dispatch}, message) {
            let messagePosition = 'left';
            let actionMessage = null;
            try {
                let messageData = JSON.parse(message.data);
                messagePosition = messageData.idTipoEmisor === TIPO_EMISOR.USUARIO ? 'right' : 'left';

                let messageType = messageData.tipo;
                actionMessage = serverMessageHandler[messageType].createMessage({messageData, messagePosition, state, dispatch});
                
                if(!state.conversationId){
                    commit('setConversationId', messageData.codigoConversacion);
                }
                if(!state.agentIsConnected && messageData.idTipoEmisor === TIPO_EMISOR.AGENTE){
                    commit('talktoAgent', true, {root: true});
                    commit('setAgentIsConnected', true);
                    commit('setDisableInput', false, {root: true});
                }
            } catch(error){}
            
            if(actionMessage) {
                commit('addMessage', actionMessage, {root: true});
            } else {
                commit('addMessage', serverMessageHandler[DEFAULT_MESSAGE_TYPE].createMessage({message, messagePosition}), {root: true});
            }
        },
        handleOnError({commit, dispatch}, errorEvent) {
            console.log('civiichat error', errorEvent);
            dispatch('handleOnMessage', 'error de conexion, se procede a cerrar.');
            commit('talktoAgent', false, {root: true});
            commit('setDisableInput', false, {root: true});
            commit('setConnection', null);
            commit('setUserCredentials', null);
            commit('setConversationId', null);
        },
        handleOnClose({commit}, closeEvent){
            console.log('civiichat close', closeEvent);
            commit('setDisableInput', false, {root: true});
            commit('talktoAgent', false, {root: true});
            commit('setUserCredentials', null);
            commit('setConnection', null);
        },
        createConnection({commit, dispatch}, conectionOptions = {}) {
            const url = `${ENDPOINT_CIVII_CHAT_USER_CHANNEL}?codigoConversacionCivii=${conectionOptions.conversationId}&codigoOperacion=${conectionOptions.workspaceId}&tipoIngreso=${conectionOptions.accessTypeId}`;
            const handlersOptions = {
                onOpenHandler: function(e){
                    dispatch('handleOnOpen', e);
                },
                onMessageHandler: function(e){
                    dispatch('handleOnMessage', e);
                }, 
                onErrorHandler: function(e){
                    dispatch('handleOnError', e);
                },
                onCloseHandler: function(e){
                    dispatch('handleOnClose', e);
                }
            }
            commit('setConnection', new CiviiChatConnection(url, handlersOptions));
            commit('setUserCredentials', conectionOptions.userCredentials);
            commit('setConversationId', conectionOptions.conversationId);
        },
        closeConnection({state, commit}){
            commit('setAgentIsConnected', false);
            commit('setConversationId', null);
            if(state.serverConnection && state.serverConnection.isOpen()) {
                state.serverConnection.close();
            }
        },
        sendMessageToAgent({state}, message){
            if(state.serverConnection && state.serverConnection.isOpen()){
                let civiiChatMessage = {
                    idTipoEmisor: TIPO_EMISOR.USUARIO,
                    tipo: TIPO_MENSAJE.CONVERSACION,
                    nombreEmisor: state.userCredentials.nombreCompleto,
                    codigoConversacion: state.conversationId,
                    codigoOperacion: state.userCredentials.codigoOperacion, 
                    mensaje: message
                }
                state.serverConnection.sendMessage(JSON.stringify(civiiChatMessage));
            } else {
                console.log('agentes no disponibles');
            }
        }
    }
};

function createCiviiTextMessage(message, position){
    return {
        type: 'Normal',
        side: position,
        messages: [
            { text: message }
        ]
    }
}


function parseMessageData(e){
    if(typeof e === 'object') {
        if(e)
        try {
            return JSON.parse(e.data).mensaje;
        } catch(e){
            return JSON.stringify(e.data);
        }
    } 
    return e;
}


// WEBPACK FOOTER //
// ./src/civii-chat/store/civiiChatStore.js